import registry from "./districts.json" with { type: "json" };

export type District = (typeof registry)[number];
export const DISTRICTS = registry as readonly District[];
export interface DirectoryEntry { path:string; label:string; family?:string }
const ROUTE_LABELS:Record<string,string>={
  "/":"Garden","/market":"Market","/market/:slug":"Product","/discussion/:id":"Discussion","/library":"Library",
  "/services":"Services","/services/:slug":"Service pavilion","/bookings":"My Bookings","/inbox":"Inbox","/academy":"Academy",
  "/academy/:slug":"Course","/learning":"My Learning","/certificate":"Certificate verification","/certificate/:code":"Certificate",
  "/insights":"Insights","/ai":"Personal AI","/profile":"My Space","/cart":"Cart",
};
export const DIRECT_DIRECTORY:DIRECTORY = DISTRICTS.flatMap((district)=>district.routes).map((path)=>({
  path,label:ROUTE_LABELS[path]??path,...(path.includes("/:")?{family:path.slice(0,path.indexOf(":"))}:{}),
})).sort((a,b)=>Object.keys(ROUTE_LABELS).indexOf(a.path)-Object.keys(ROUTE_LABELS).indexOf(b.path));
type DIRECTORY=readonly DirectoryEntry[];

function matchesFamily(pathname: string, family: string) {
  const dynamic = family.endsWith("/:slug") || family.endsWith("/:id") || family.endsWith("/:code");
  if (!dynamic) return pathname === family;
  const base = family.slice(0, family.lastIndexOf("/"));
  return pathname.startsWith(`${base}/`) && pathname.length > base.length + 1 && !pathname.slice(base.length + 1).includes("/");
}

export function resolveDistrict(pathname: string) {
  return DISTRICTS.find((district) => district.routes.some((family) => matchesFamily(pathname, family)));
}

export function isServiceRoute(pathname: string) {
  return resolveDistrict(pathname)?.districtId === "service-pavilion";
}

export function districtForPath(pathname:string){
  const district=resolveDistrict(pathname)??DISTRICTS[0]!;
  return {...district,label:district.districtLabel,primarySceneId:district.sceneId};
}

export { matchesFamily };
